<template>
  <div class="fields">
    <v-layout row wrap>
      <v-flex md4>
        <label for="">Label</label>
        <v-text-field
          v-model="field.label"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <label for="">Key</label>
        <v-text-field
          v-model="field.key"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <label for="">Type</label>
        <v-select
          v-model="field.type"
          outline
          :items="['textfield','select','textarea','radio','time','date', 'rating']"
        ></v-select>
      </v-flex>
      <v-flex md4>
        <label for="">Regex</label>
        <v-text-field
          v-model="field.regex"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <label for="">Regex Android</label>
        <v-text-field
          v-model="field.regex_android"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <label for="">Regex IOS</label>
        <v-text-field
          v-model="field.regex_ios"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex md9>
        <label for="">Error message</label>
        <v-text-field
          v-model="field.errorMessage"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex md3>
        <label for="">Required</label>
        <v-switch
          v-model="field.required"
        ></v-switch>
      </v-flex>
      <v-flex md8 v-if="hasOptions">
        <label for="">Options</label>
        <v-combobox
          v-model="field.options"
          :items="[]"
          chips
          outline
          solo
          multiple
        >
        </v-combobox>
      </v-flex>
      <v-flex md2 v-if="hasMultiple">
        <label for="">Multiple selection</label>
        <v-switch
          v-model="field.multiple"
        ></v-switch>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    name: "fields",
    props: {
      field: {
        type: Object,
        default: ()=>{
          return []
        }
      }
    },
    computed: {
      hasOptions() {
        let optionsList= ['select','radio']
        return optionsList.includes(this.field.type)
      },
      hasMultiple() {
        let optionsList= ['select']
        return optionsList.includes(this.field.type)
      }
    }
  }
</script>

<style scoped>

</style>
